/**
 * This was taken from https://stackoverflow.com/questions/56173848/want-to-convert-a-nested-object-to-query-parameter-for-attaching-to-url
 */
const getPairs = (obj, keys = []) => {
  return Object.entries(obj).reduce((pairs, [key, value]) => {
    if (typeof value === 'object' && !!value) pairs.push(...getPairs(value, [...keys, key]))
    else pairs.push([[...keys, key], value || ''])

    return pairs
  }, [])
}

export default function toUrl(obj) {
  return getPairs(obj)
    .map(([[key0, ...keysRest], value]) => `${key0}${keysRest.map((a) => `[${a}]`).join('')}=${value}`)
    .join('&')
}
